export const projectData = [
  {
    id: 4,
    title: "FROM HEARTS TO HANDS",
    link: "http://fromhearts2hands.org/",
    text: "The goal of From Hearts 2 Hands is to bridge the gap between simple thoughts of goodwill and physical actions of goodwill.",
    footer: "2022 · Missions",
    imgSrc: "assets/Church_hearts.jpg",
    imgAlt: "HEARTS",
  },
  {
    id: 5,
    title: "NOTHING BUT NETS PROJECT",
    link: "https://nothingbutnets.net/donate/",
    text: "Nothing But Nets is a global grassroots campaign to raise awareness, funds, and voices to fight malaria.",
    footer: "2022 · Missions",
    imgSrc: "assets/Church_Malaria_project.jpg",
    imgAlt: "NETS",
  },
];

export const linksData = [
  {
    id: 2,
    title: "Bible Study",
    link: "https://sabbath-school.adventech.io/en",
    text: "View this week's bible study lesson.",
    footer: "2022 · Ministries",
    imgSrc: "assets/Church_bible.jpg",
    imgAlt: "LEARNING",
  },
  {
    id: 3,
    title: "Weekly Message",
    link: "/watching",
    text: "View this week's sermon.",
    footer: "2022 · Ministries",
    imgSrc: "assets/Church_podium.jpg",
    imgAlt: "WATCHING",
  },
  {
    id: 4,
    title: "Tithe & Offering",
    link: "https://adventistgiving.org/donate/ANPMAL",
    text: "View our giving page.",
    footer: "2022 · Missions",
    imgSrc: "assets/Church_front.jpg",
    imgAlt: "GIVING",
  },
  {
    id: 1,
    title: "Schedule",
    link: "/bulletin",
    text: "View this week's bulletin.",
    footer: "2022 · Ministries",
    imgSrc: "assets/Church_bulletin.png",
    imgAlt: "BULLETIN",
  },
];